import { Component, OnInit, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PericiasService } from '../../core/services/pericias.service';
import { Pericia, ProgramaTrabalho } from '../../core/models/pericia.model';

interface DiaCalendario {
  data: string;
  dia: number | null;
  foraMes: boolean;
  tarefas: ProgramaTrabalho[];
}

@Component({
  selector: 'app-calendario',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './calendario.component.html',
  styleUrl: './calendario.component.scss'
})
export class CalendarioComponent implements OnInit {
  pericias = signal<Pericia[]>([]);
  tarefas = signal<ProgramaTrabalho[]>([]);

  hoje = new Date();
  ano = this.hoje.getFullYear();
  mes = String(this.hoje.getMonth() + 1).padStart(2, '0');
  periciaFiltro = 0;

  meses = [
    { valor: '01', nome: 'Janeiro' }, { valor: '02', nome: 'Fevereiro' },
    { valor: '03', nome: 'Março' }, { valor: '04', nome: 'Abril' },
    { valor: '05', nome: 'Maio' }, { valor: '06', nome: 'Junho' },
    { valor: '07', nome: 'Julho' }, { valor: '08', nome: 'Agosto' },
    { valor: '09', nome: 'Setembro' }, { valor: '10', nome: 'Outubro' },
    { valor: '11', nome: 'Novembro' }, { valor: '12', nome: 'Dezembro' }
  ];

  semana = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

  constructor(private readonly service: PericiasService) {}

  ngOnInit(): void {
    this.carregar();
  }

  carregar(): void {
    this.service.listar().subscribe(dados => this.pericias.set(dados));
    this.service.listarProgramasTrabalho().subscribe(dados => this.tarefas.set(dados));
  }

  tarefasFiltradas = computed(() => {
    const prefixo = `${this.ano}-${this.mes}`;
    return this.tarefas().filter(t => {
      const bateMes = (t.data_prevista || '').startsWith(prefixo);
      const batePericia = !this.periciaFiltro || t.pericia_id === Number(this.periciaFiltro);
      return bateMes && batePericia;
    });
  });

  diasCalendario(): DiaCalendario[] {
    const ano = Number(this.ano);
    const mesIndex = Number(this.mes) - 1;
    const primeiro = new Date(ano, mesIndex, 1);
    const ultimo = new Date(ano, mesIndex + 1, 0);
    const dias: DiaCalendario[] = [];

    for (let i = 0; i < primeiro.getDay(); i++) {
      dias.push({ data: '', dia: null, foraMes: true, tarefas: [] });
    }

    for (let dia = 1; dia <= ultimo.getDate(); dia++) {
      const data = `${ano}-${this.mes}-${String(dia).padStart(2, '0')}`;
      dias.push({
        data,
        dia,
        foraMes: false,
        tarefas: this.tarefasFiltradas().filter(t => t.data_prevista === data)
      });
    }

    while (dias.length % 7 !== 0) {
      dias.push({ data: '', dia: null, foraMes: true, tarefas: [] });
    }

    return dias;
  }

  nomePericia(id: number): string {
    const p = this.pericias().find(x => x.id === id);
    return p ? `${p.codigo} - ${p.titulo}` : `Perícia ${id}`;
  }

  classeStatus(status: string): string {
    return 'status-' + (status || 'padrao').toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-');
  }
}
